import { getClasses, getComponent, getID } from './../../common/utils';

Cell.version = 1000;
Object.defineProperty(Cell, 'name', {
  writable: true,
  value: 'Cell'
});

export function Cell(props: any) {

    //console.log("celllllprops.dataprops.dataprops.dataprops.data", props.data);
    let componentClasses = getClasses(props.data);
    //console.log("cellcomponentClassescomponentClassescomponentClasses" + componentClasses);
    let componentID = getID(props.data);
    let childCells:any = "";
    if( props.data.components ) {
        childCells = getComponent(props.data.components);
    }

    return (
        <div id={componentID} className={componentClasses} data-have="cell" data-slott={JSON.stringify(props.data)}>
            {childCells}
        </div>
    )
    
}
